import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Layout, Menu, Breadcrumb, Space } from 'antd';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import SignIn from '../Header/SignIn';
import LoggedIn from '../Header/LoggedIn';
import { signIn as signInAction, signOut as signOutAction } from '../../actions/app.action';


const { Header, Content, Footer } = Layout;

const HomePageLayout = ({ children, user, signIn, signOut }) => {

  const history = useHistory();

  const onSignIn = async (googleUser) => {
    var profile = googleUser.getBasicProfile();
    console.log('ID: ' + profile.getId()); // Do not send to your backend! Use an ID token instead.
    console.log('Name: ' + profile.getName());
    console.log('Image URL: ' + profile.getImageUrl());
    console.log('Email: ' + profile.getEmail()); // This is null if the 'email' scope is not present.
    var id_token = googleUser.getAuthResponse().id_token;

    console.log("googleUser.getAuthResponse()", googleUser.getAuthResponse());

    await signIn(id_token);

    window.location.reload();


    // var xhr = new XMLHttpRequest();
    // xhr.open('POST', 'http://localhost:8080/v1/users/sign-in');
    // xhr.onload = function() {
    //     console.log('Signed in as: ' + xhr.responseText);
    // };

    // xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    // xhr.send(JSON.stringify({ "idToken": id_token }));
  }

  const onSignOut = async () => {
    console.log('call to sing out');
    await signOut();
    window.location.reload();
  }

  const onGoToApiDocViewer = () => {
    history.push({ pathname: '/admin/api-doc-view' });
  }

  const onGotoIntegrationGuide = () => {
    history.push({ pathname: '/admin/guide-line' });
  }

  const gotoHome = () => {
    history.push({ pathname: '/' });
  }


  return (
    <Layout>
      <Header style={{ position: 'fixed', zIndex: 99995, width: '100%', padding: 0 }}>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          height: '100%',
          width: '100%',
          alignItems: 'center',
        }}>
          <Link to="/">
            <div
              style={{
                height: 64,
                background: 'rgb(26, 148, 255)',
                width: 200,
                padding: 12,
                display: 'block'
              }}
            >
              <img style={{ objectFit: 'contain', width: '100%', height: '100%', display: 'block' }} src={`${process.env.PUBLIC_URL}/tiki.png`} alt="Tiki Logo" />
            </div>
          </Link>
          <div style={{
            display: 'flex',
            height: '100%',
            justifyContent: 'flex-end',
            alignItems: 'center',
            padding: '0 10px 0 10px'
          }}>
            <Space>
              {user && <div>
                <Menu theme="dark" mode="horizontal">
                  <Menu.Item key="1"><Link to="/admin">Admin</Link></Menu.Item>
                </Menu>
              </div>}
              {user == null
                ? <SignIn onSignIn={onSignIn} />
                : <LoggedIn onSignOut={onSignOut} onGoToApiDocViewer={onGoToApiDocViewer} onGotoIntegrationGuide={onGotoIntegrationGuide} user={user} />
              }
            </Space>
          </div>
        </div>
      </Header>
      <Content className="site-layout" style={{ padding: '0 50px', marginTop: 64 }}>
        <div className="site-layout-background" style={{ padding: 24, minHeight: 380 }}>
          {children}
        </div>
      </Content>
    </Layout>
  )
}

const mapStateToProps = state => ({
  user: state.app.user
});

const mapPropsToDispatch = dispatch => ({
  signIn: (token) => dispatch(signInAction(token)),
  signOut: () => dispatch(signOutAction())
});


export default withRouter(connect(mapStateToProps, mapPropsToDispatch)(HomePageLayout));
